// extracted by mini-css-extract-plugin
module.exports = {"main-header":"MainHeader_main-header__2OmAM"};